import gridView from '@/global/components/grid/GridView.vue'
import documentsGridBlock from '../../components/documentsGridBlock.vue'
import { api } from '@/global/services/api'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { dateService, FORMATS } from '@/global/services/date'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'
export default {
  name: 'documents',

  computed: {
    documentsConfig () {
      return {
        title: this.$t('people/person.documents'),
        key: 'documents',
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        tabContent: [
          {
            component: this.tableGridComponent,
            editable: false,
            apiConfig: {
              get: {
                module: 'people',
                route: 'person-documents',
                method: 'get',
                queryParams: {
                  person_id: this.$route.params.id
                }
              }
            },
            rowDblClick: (event) => this.onShowDocument(event),
            mobileConfig: {
              title: this.$t('people/person.documents')
            },
            title_and_back_config: {
              title: this.$t('people/person.documents')
            },
            search_and_buttons_config: {
              newClick: () => this.onNewDocument()
            },
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: documentsGridBlock,
                onEdit: (event) => this.onShowDocument(event),
                onDelete: (event) => this.onDocumentDelete(event)
              },
              useBorder: false
            },
            tableConfig: {
              cellsConfig: {
                person_document_id: {
                  custom_display_value: (item) => {
                    return item?.person_document_id?.display_name || ''
                  }
                },
                valid_from: {
                  custom_display_value: (item) => {
                    return item?.valid_from ? dateService.formatCustom(item.valid_from, FORMATS.isoDate, FORMATS.date) : ''
                  }
                },
                valid_to: {
                  custom_display_value: (item) => {
                    return item?.valid_to ? dateService.formatCustom(item.valid_to, FORMATS.isoDate, FORMATS.date) : ''
                  }
                }
              },
              headers: [
                {
                  label: this.$t('people/person_document.type'),
                  key: 'person_document_id',
                  always_visible: true
                },
                {
                  label: this.$t('people/person_document.show_table_valid_from'),
                  key: 'valid_from',
                  always_visible: true
                },
                {
                  label: this.$t('people/person_document.show_table_valid_to'),
                  key: 'valid_to',
                  always_visible: true
                },
                {
                  label: this.$t('people/person_document.alarm_on'),
                  key: 'alarm_on',
                  style: {
                    width: '120px'
                  },
                  always_visible: true,
                  component: () => import('../../components/main-table/ActiveIcon.vue')
                }
              ],
              actionsConfig: [
                showDetailsAction(this.$t, (event) => this.onShowDocument(event)),
                deleteAction(this.$t, (event) => this.onDocumentDelete(event))
              ],
              paginationConfig: {
                perPageOptions: [5, 10, 20, 50, 100]
              },
              filtersConfig: {
                fields: [
                  {
                    key: 'type',
                    label: this.$t('people/person_document.type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'person-documents/autocomplete'
                    }
                  },
                  {
                    key: 'valid_from',
                    label: this.$t('people/person_document.valid_from'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date
                  },
                  {
                    key: 'valid_to',
                    label: this.$t('people/person_document.valid_to'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date
                  }
                ]
              }
            }
          }
        ]
      }
    }
  },

  methods: {
    onNewDocument () {
      this.$set(this.manageDocumentsDialogConfig, 'title', this.$t('people/person.adding_new_document'))
      this.$set(this.manageDocumentsDialogConfig, 'createMode', true)
      this.$set(this.manageDocumentsDialogConfig, 'editData', null)
      this.$set(this.manageDocumentsDialogConfig, 'show', true)
    },

    onShowDocument (event) {
      const { data } = event || {}
      this.$set(this.manageDocumentsDialogConfig, 'title', this.$t('people/person.updating_document'))
      this.$set(this.manageDocumentsDialogConfig, 'createMode', false)
      this.$set(this.manageDocumentsDialogConfig, 'editData', data)
      this.$set(this.manageDocumentsDialogConfig, 'show', true)
    },

    onDocumentDelete (event) {
      const { display_name: name } = event?.data?.person_document_id || {}
      this.$set(this.informationDialogConfig, 'title', this.$t('people/person.delete_document_dialog_title') + ' - ' + name || '')
      this.$set(this.informationDialogConfig, 'message', this.$t('people/person.delete_document_dialog_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', async () => await this.deleteDocumentCallback(event))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    async deleteDocumentCallback (event) {
      try {
        const { id: deleteId } = event?.data || {}
        if (!deleteId) {
          return
        }

        await api('people').delete(`person-documents/${deleteId}`)
        const { fetchData } = registeredTableHandlers?.documents || {}
        if (typeof fetchData === 'function') {
          fetchData()
        }
        this.$set(this.informationDialogConfig, 'showDialog', false)
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
